var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showActions
    ? _c(
        "div",
        { attrs: { "data-component": "app-launcher-warning-actions" } },
        [
          _vm.showError
            ? _c("or-code", {
                attrs: {
                  "model-value": _vm.code,
                  readonly: true,
                  "enable-fullscreen": false,
                  language: "json",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.appState === "warning-no-app-available"
            ? _c(
                "or-button",
                {
                  attrs: { "data-button": "install", loading: _vm.isUpdating },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("app-install")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm.$t("HITL.common.actions.install")) +
                      "\n  "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.appState === "warning-no-app-version"
            ? _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "or-button",
                    {
                      attrs: {
                        "data-button": "go-to-launcher",
                        variant: "outlined",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("go-to-launcher")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t("HITL.modules.app-header.back-to-launcher")
                          ) +
                          "\n    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "or-button",
                    {
                      attrs: {
                        "data-button": "accept",
                        loading: _vm.isLoading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("accept-version")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_vm.useVersionLabel) + "\n    "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.appState === "warning-no-app-version-support"
            ? _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "or-button",
                    {
                      attrs: {
                        "data-button": "update",
                        loading: _vm.isUpdating,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("app-update")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_vm.useVersionLabel) + "\n    "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.appState === "warning-data-update-error-admin"
            ? _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "or-button",
                    {
                      attrs: {
                        "data-button": "go-to-launcher",
                        variant: "outlined",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("go-to-launcher")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t("HITL.modules.app-header.back-to-launcher")
                          ) +
                          "\n    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.vSuggest
                    ? _c(
                        "or-button",
                        {
                          attrs: {
                            "data-button": "accept",
                            variant: "outlined",
                            loading: _vm.isLoading,
                            disabled: _vm.isUpdating,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("accept-version")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n      " + _vm._s(_vm.useVersionLabel) + "\n    "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "or-button",
                    {
                      attrs: {
                        "data-button": "retry",
                        loading: _vm.isUpdating,
                        disabled: _vm.isLoading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("retry-update")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("HITL.common.actions.retry")) +
                          "\n    "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.appState === "warning-needs-data-update"
            ? _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "or-button",
                    {
                      attrs: {
                        "data-button": "cancel",
                        variant: "outlined",
                        disabled: _vm.isUpdating,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("cancel")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("HITL.common.actions.cancel")) +
                          "\n    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "or-button",
                    {
                      attrs: {
                        "data-button": "update",
                        loading: _vm.isUpdating,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("update")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("HITL.common.actions.update")) +
                          "\n    "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showBackToLauncher
            ? _c(
                "or-button",
                {
                  staticClass: "go-to-launcher-button",
                  attrs: { "data-button": "go-to-launcher" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("go-to-launcher")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(
                        _vm.$t("HITL.modules.app-header.back-to-launcher")
                      ) +
                      "\n  "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }